<template>
  <div class="personQuantity" :class="{'productReturnCardSeparator': index > 0}">
    <div class="personName">{{displayName}}</div>
    <div class="itemQuantity">
      <div class="quantityLabel">{{quantityLabel.toUpperCase()}}</div>
      <NsSlottedDropdown
        :id="'returnSelector_' + productSku + '_' + customerId"
        small
        class="personQuantityDropdown"
        :selected="selectedValue ? selectedValue.toString() : '0'"
        :width="60"
        @select="select">
        <span v-for="(n, i) in totalQuantity + 1" :key="n" :data-value="i.toString()">
          {{i}}
        </span>
      </NsSlottedDropdown>
      <div class="totalQuantity">/{{totalQuantity}}</div>
    </div>
  </div>
</template>

<script>
import {
  NsSlottedDropdown,
} from '@nuskin/design-components'
export default {
  components: {
    NsSlottedDropdown,
  },
  computed: {
    displayName: function() {
      let newName = this.personName
      if (!this.personName || ['', 'tdc_unidentifiedQualificationSharer'].includes(this.personName)) {
        newName = this.defaultName
      }
      return newName
    },
  },
  methods: {
    select(value) {
      this.$emit('select', {
        quantity: Number.parseInt(value),
        customerId: this.customerId,
      })
    },
  },
  props: {
    customerId: {
      type: String,
      default: '',
    },
    defaultName: {
      type: String,
      required: true,
    },
    selectedValue: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
    },
    personName: {
      type: String,
      default: '',
    },
    quantityLabel: {
      type: String,
      default: 'Quantity',
    },
    totalQuantity: {
      type: Number,
      default: 0,
    },
    productSku: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
  .productReturnCardSeparator {
    border-top: 1px solid #DADBDB;
    width: 100%;
    padding-top: 15px;
  }
  .personQuantity {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    color: #272525;
    .personName {
      font-size: 16px;
      font-weight: 600;
    }
    .itemQuantity {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .quantityLabel {
        font-size: 12px;
        font-weight: 600;
        margin-right: 5px;
      }
      .personQuantityDropdown {
        margin-right: 5px;
        .dropdown-area {
          .current-selection {
            height: 25px;
            min-height: 25px;
            border: 1px solid #63666A;
            display: flex;
            justify-content: space-between;
            .selected-item {
              display: initial;
            }
          }
        }
      }
      .totalQuantity {
        font-size: 13px;
        font-weight: 700;
      }
    }
  }
</style>
